var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHandicapped = function SvgHandicapped(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "14px",
    viewBox: "0 0 13 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.933333, 7.000000) scale(-1, 1) translate(-6.933333, -7.000000) translate(1.933333, 1.000000)",
    stroke: "#282828"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.16727273,9.90545455 C5.70181818,11.0690909 4.65454545,11.8836364 3.25818182,11.8836364 C1.51272727,11.8836364 0.232727273,10.4872727 0.232727273,8.85818182 C0.232727273,7.57818182 1.04727273,6.53090909 2.09454545,6.06545455"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "9.54181818 10.9527273 8.72727273 10.9527273 7.56363636 7.92727273 4.30545455 7.92727273 3.84 5.01818182 7.68 4.90181818"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.84,
    cy: 1.64363636,
    r: 1.51272727
  }))))));
};
export default SvgHandicapped;